import { useState, useId } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FlexSpacer } from 'ui/flexSpacer';
import { DestructiveButton, SecondaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Container } from 'ui/container';
import { PageHeader } from 'ui/pageHeader';
import { selectIsBossOrSalesBossLevel } from 'core/userContext';
import { EventUploaderModal } from './EventUploaderModal';
import { DemoDataDeleteModal } from './DemoDataDeleteModal';
import { generateDemoAccountRequest } from '../actions';
import { getEventUploaderApiIsLoading } from '../selectors';

export const DemoData = () => {
  const dispatch = useDispatch();
  const formId = useId();
  const emailFormId = useId();
  const projectNameFormId = useId();
  const isBaus = useSelector(selectIsBossOrSalesBossLevel);
  const eventUploaderApiIsLoading = useSelector(getEventUploaderApiIsLoading);

  const [openWarning, setOpenWarning] = useState(false);
  const [openEventUploader, setOpenEventUploader] = useState(false);
  const [projectName, setProjectName] = useState('DemoTest');
  const [email, setEmail] = useState('demo@iterable.com');

  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setOpenWarning(true);
  };

  const onDelete = (confirmText: string) => {
    if (confirmText === projectName) {
      dispatch(generateDemoAccountRequest(email, projectName));
      setOpenWarning(false);
    }
  };

  if (!isBaus) {
    return null;
  }

  return (
    <>
      {openWarning && (
        <DemoDataDeleteModal onClose={() => setOpenWarning(false)} onDelete={onDelete} />
      )}
      {openEventUploader && <EventUploaderModal onClose={() => setOpenEventUploader(false)} />}
      <PageHeader
        pageActions={
          <SecondaryButton
            isDisabled={!!eventUploaderApiIsLoading}
            onClick={() => setOpenEventUploader(true)}
          >
            Create demo data
          </SecondaryButton>
        }
      >
        Generate demo data for account
      </PageHeader>
      <Container hasBorder={false}>
        <FlexSpacer flexDirection="column" alignItems="flex-start" gap="base">
          <form id={formId} onSubmit={onSubmitForm}>
            <FormField labelText="Project email" inputId={emailFormId} isHorizontalLayout>
              <InputText
                id={emailFormId}
                name="email"
                placeholder="demo@iterable.com"
                onChange={(newVal) => setEmail(newVal)}
                value={email}
              />
            </FormField>
            <FormField labelText="Project name" inputId={projectNameFormId} isHorizontalLayout>
              <InputText
                id={projectNameFormId}
                name="projectName"
                placeholder="Team Iterable Demo"
                onChange={(newVal) => setProjectName(newVal)}
                value={projectName}
              />
            </FormField>
          </form>
          <DestructiveButton type="submit" form={formId}>
            Regenerate Demo Account
          </DestructiveButton>
        </FlexSpacer>
      </Container>
    </>
  );
};
